import { render, staticRenderFns } from "./SelectUserModal.vue?vue&type=template&id=08f00a36&"
import script from "./SelectUserModal.vue?vue&type=script&lang=js&"
export * from "./SelectUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports